module.exports = __webpack_public_path__ + "img/1518151181.5e23c116.jpg";